export const companyStudentDeviceTitle = {
  type: 'string',
  minLength: 1,
  maxLength: 255,
};
